import {
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { allVistasAction } from '../../../sistema/vistas/VistasAction';
import { saveEntVistasAction } from '../EntVistasAction';

const FormEntVistas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const vistasStore = Redux.useSelector((state) => state.vistas);
  const entVistasStore = Redux.useSelector((state) => state.entVistas);

  const activo = entVistasStore.activo;

  const initData = {
    idVista: '',
    isInicio: false,
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    idVista: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [vistas, setVistas] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      if (vistasStore.all.length === 0) {
        await allVistasAction(dispatch, null);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    getVistas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vistasStore.all]);

  function getVistas() {
    const list = [];
    vistasStore.all.forEach((el) => {
      const select = entVistasStore.all.find((c) => c.vista.id === el.id);
      if (!select) list.push(el);
    });
    setVistas(list);
  }

  React.useEffect(() => {
    getVistas();
    if (!activo) return;
    setData({
      idVista: activo.vista.id,
      idEstatus: activo.estatus.id,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la vista', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveEntVistasAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
        },
        entVistasStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        <LoadingWidget isLoading={loadingSave} isActivo={activo} />
        {!activo && (
          <Grid item xs={12} md={12}>
            {vistasStore.loadingAll ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              <FormControl
                fullWidth
                size="small"
                required
                error={dataError.idVista}
              >
                <InputLabel id={`label_${CONST.vista.name}`}>
                  {CONST.vista.label}
                </InputLabel>
                <Select
                  id={CONST.vista.name}
                  required
                  value={data.idVista}
                  labelId={`label_${CONST.vista.name}`}
                  label={CONST.vista.label}
                  onChange={(e) =>
                    _handleSetDataField(CONST.vista.idName, e.target.value)
                  }
                >
                  {vistas.map((el, index) => {
                    return (
                      <MenuItem key={`vista-${el.index}`} value={el.id}>
                        {el.nombre}
                      </MenuItem>
                    );
                  })}
                </Select>
                {dataError.idVista && (
                  <FormHelperText>{validMessage.required}</FormHelperText>
                )}
              </FormControl>
            )}
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Switch
                checked={data.isInicio}
                onChange={(event) => {
                  _handleSetDataField(
                    CONST.isInicio.name,
                    event.target.checked,
                  );
                }}
              />
            }
            label="Colocar en el inicio"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEntVistas;
